import { Form, Formik } from "formik";
import { APPLY_BUTTON_STYLE, RESET_BUTTON_STYLE } from "./reportCommon";
import { DEFAULT_WARD_COVERAGE_FILTERS } from "./staticReportData";

const WardCoverageFilter = ({
  initialValues = DEFAULT_WARD_COVERAGE_FILTERS,
  wardOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <select
              name="wardId"
              value={values.wardId}
              onChange={(event) => setFieldValue("wardId", event.target.value)}
              className="form-select bg-white"
            >
              <option value="">Select Ward</option>
              {wardOptions.map((ward) => (
                <option key={ward.wardId} value={ward.wardId}>
                  {ward.wardName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">From Date &amp; Time</label>
            <input
              type="datetime-local"
              name="fromDateTime"
              value={values.fromDateTime}
              onChange={(event) =>
                setFieldValue("fromDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date &amp; Time</label>
            <input
              type="datetime-local"
              name="toDateTime"
              value={values.toDateTime}
              min={values.fromDateTime || undefined}
              onChange={(event) =>
                setFieldValue("toDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                resetForm({ values: DEFAULT_WARD_COVERAGE_FILTERS });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default WardCoverageFilter;
